import React from "react";

const ActivityCard = ({ title, items }) => (
  <div className="w-full sm:w-1/2">
    <div className="p-4 rounded">
      <div className="border-2 p-5 shadow-2xl group duration-200 rounded-2xl hover:shadow-none bg-[#7decc6] bg-opacity-10">
        <p className="uppercase text-black text-2xl py-5 font-bold mb-0">
          {title}
        </p>
        <div className="text-lg space-y-2 text-[#2e3a46] font-medium list-disc">
          {items.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </div>
      </div>
    </div>
  </div>
);

const Activities = () => {
  const leftCard = [
    {
      title: "Reports on Online available data",
      items: [
        "Return Status",
        "Cash & ITC balance",
        "Challan history",
        "Cash/ Credit/ Liability Ledger",
        "Tax liability & ITC Comparison",
      ],
    },
    {
      title: "Outward-Inward data Reconciliation",
      items: [
        "GSTR 3B with GSTR 1",
        "GSTR 3B, GSTR 1 & GSTR 2B/2A",
        "GSTR 2B/2A with Accounts",
        "GSTR 2B with GSTR 2A",
        "Invoice & Party Wise Reconciliation",
      ],
    },
  ];

  const rightCard = [
    {
      title: "Outward-Inward data Summary",
      items: [
        "GSTR 1 Summary and Analysis",
        "GSTR 3B Summary and Analysis",
        "GSTR 2B/2A Summary",
      ],
    },
    {
      title: "Input Tax Credit (ITC) Reports",
      items: [
        "GSTR 3B with GSTR 2B/2A",
        "GSTR 2B/2A/3B with Accounts data",
        "GSTR 2A with GSTR 2B",
      ],
    },
  ];

  return (
    <div className="relative bg-[#f1f5f8] py-6 flex flex-col justify-center sm:py-12">
      <div className="py-3 sm:max-w-4xl sm:mx-auto w-full px-2 sm:px-0">
        <div className="relative text-gray-700 antialiased text-sm font-semibold">
          <div className="text-center text-4xl">
            <p className="text-black">
              Online Activities <span className="text-[#519980]">&</span>{" "}
              Analysis Reports
            </p>
          </div>
          <div className="hidden sm:block w-1 bg-[#7decc6] absolute h-full left-1/2 transform -translate-x-1/2"></div>

          {/* LeftSide Cards */}
          <div className="mt-6 sm:mt-0 sm:mb-12">
            <div className="flex flex-col sm:flex-row items-center">
              {leftCard.map((card, index) => (
                <ActivityCard
                  key={index}
                  title={card.title}
                  items={card.items}
                />
              ))}
              <div className="rounded-full hidden sm:flex bg-[#7decc6] border-white border-4 w-8 h-8 absolute left-1/2 -translate-y-4 sm:translate-y-0 transform -translate-x-1/2  items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="#000000"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                  />
                </svg>
              </div>
            </div>
          </div>

          {/* RightSide Cards */}
          <div className="mt-6 sm:mt-0 sm:mb-12">
            <div className="flex flex-col sm:flex-row items-center justify-end">
              {rightCard.map((card, index) => (
                <ActivityCard
                  key={index}
                  title={card.title}
                  items={card.items}
                />
              ))}
              <div className="rounded-full hidden bg-[#7decc6] border-white border-4 w-8 h-8 absolute left-1/2 -translate-y-4 sm:translate-y-0 transform -translate-x-1/2 sm:flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 text-white"
                  fill="black"
                  class="bi bi-database-check"
                  viewBox="0 0 16 16"
                >
                  <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514" />
                  <path d="M12.096 6.223A5 5 0 0 0 13 5.698V7c0 .289-.213.654-.753 1.007a4.5 4.5 0 0 1 1.753.25V4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.5 4.5 0 0 1-.813-.927Q8.378 15 8 15c-1.464 0-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13h.027a4.6 4.6 0 0 1 0-1H8c-1.464 0-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10q.393 0 .774-.024a4.5 4.5 0 0 1 1.102-1.132C9.298 8.944 8.666 9 8 9c-1.464 0-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777M3 4c0-.374.356-.875 1.318-1.313C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Activities;
